<template>
	<div v-if="endload" :key="uuid()">
		<div v-if="fetched_array.length">
			<div v-for="answ in fetched_array">
				{{ answ.name }} - {{ answ.percentage }}%
				<el-button v-if="answ.checked || isSuperAdmin" @click="$emit('add', answ)">{{ $t("add") }}</el-button>
				<span style="color: red" v-else>{{ $t("not-included") }}</span>
			</div>
		</div>
		<div v-else>{{ $t("sorry-we-cannot-help-you") }}</div>
	</div>
	<div v-else>
		<div style="display: flex; align-content: center; justify-content: center; height: 100%; width: 100%">
			<loading-generic :is-loading="!endload"></loading-generic>
		</div>
	</div>
</template>
<script>
import { uuid } from "@/modules/builder/utils/utils"
import axios from "axios"
import LoadingScreen from "@/modules/_common/loading-screen"
import { mapMutations } from "vuex"
import LoadingGeneric from "@/modules/_common/loading-generic"
import { mapGetters } from "vuex"

export default {
	name: "wizard-answer-render",
	components: { LoadingGeneric, LoadingScreen },
	props: {
		array: {
			type: Array,
			required: true
		}
	},
	computed: {
		...mapGetters({
			isSuperAdmin: "user/isSuperAdmin"
		})
	},
	data() {
		return {
			fetched_array: [],
			endload: false
		}
	},
	mounted() {
		this.array.forEach(element => {
			// console.log(element)
			let url = ""
			if (element.type == "folder") {
				url = "/api/folders/" + element.id
			} else if (element.type == "type") {
				url = "/api/tags/" + element.id
			}
			axios
				.get(process.env.VUE_APP_API_URL + url, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(async res => {
					if (element.type == "folder") {
						if (await this.checkIfAuthFolder(element.id)) {
							this.fetched_array.push({
								id: res.data.id,
								name: res.data.name,
								percentage: element.percentage,
								checked: true
							})
						} else {
							this.fetched_array.push({
								id: res.data.id,
								name: res.data.name,
								percentage: element.percentage,
								checked: false
							})
						}
					} else if (element.type == "type") {
						if (await this.checkIfAuthTag(element.id)) {
							this.fetched_array.push({
								id: res.data.id,
								name: res.data.name,
								percentage: element.percentage,
								checked: true
							})
						} else {
							this.fetched_array.push({
								id: res.data.id,
								name: res.data.name,
								percentage: element.percentage,
								checked: false
							})
						}
					}

					this.endload = true
				})
				.catch(err => console.error(err))
		})
	},
	methods: {
		uuid,
		async checkIfAuthFolder(id) {
			const payload = {
				search: ""
			}
			return await axios
				.post(`${process.env.VUE_APP_API_URL}/api/folders/getBySubscription`, payload, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})
				.then(async res => {
					var ret = false
					if (res.data.items)
						res.data.items.map(folder => {
							if (folder.folder.id == id) {
								ret = true
							}
						})

					return ret
				})
				.catch(err => {
					return false
				})
		},
		async checkIfAuthTag(id) {
			//yes
			return true
		}
	}
}
</script>
<style scoped></style>
